import { calcSpace } from '@hopin-team/ui-symbols';
import styled from 'styled-components';

export const TemplateModalFormComponent = styled.form`
  width: ${calcSpace(45)};
`;
